import "./ContactUsCardEmail.css"

export default function ContactUsCardEmail() {
  return (
    <div className="ContactUsCardEmail">lacucinakirwan@gmail.com</div>
  )
}
